import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { defaultAlert } from '../../../../utils/alert';

interface RequestEndModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (payOption: string, adjustDirection: string, adjustAmount: number) => void;
    currentTotalPay: number;
}

export const RequestEndModal: React.FC<RequestEndModalProps> = ({
                                                                    isOpen, onClose, onConfirm, currentTotalPay,
                                                                }) => {
    const [payOption, setPayOption] = useState<'keep' | 'adjust'>('keep');
    const [adjustDirection, setAdjustDirection] = useState<'deduct' | 'add'>('deduct');
    const [adjustAmount, setAdjustAmount] = useState<string>('');
    const modalRoot = document.getElementById('modal-root');

    React.useEffect(() => {
        if (isOpen) {
            document.body.classList.add('modal-open');
            setPayOption('keep');
            setAdjustDirection('deduct');
            setAdjustAmount('');
        }
        return () => document.body.classList.remove('modal-open');
    }, [isOpen]);

    if (!isOpen || !modalRoot) return null;

    const finalPay = () => {
        if (payOption === 'keep') return currentTotalPay;
        const amt = parseInt(adjustAmount) || 0;
        return adjustDirection === 'deduct' ? currentTotalPay - amt : currentTotalPay + amt;
    };

    return ReactDOM.createPortal(
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
            <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content" style={{ backgroundColor: 'white' }}>
                    <div className="modal-header line-header">
                        <h3>서비스 종료</h3>
                    </div>

                    <div className="modal-body">
                        <div className="modal-info-p mt10">
                            <strong className="block">해당 공고의 서비스 종료를 신청하시겠습니까?</strong>
                            <span className="block">공고 게시자가 종료 확인 시 </span>
                            <span className="block">협의된 돌봄 급여 금액이 정산됩니다.</span>
                        </div>

                        <div className="round-box orange mt20">
                            <div className="round-body">
                                <div className="info-row">
                                    <span className="label">현 급여 총액</span>
                                    <span className="cont small-number">{currentTotalPay.toLocaleString()}원</span>
                                </div>
                            </div>
                        </div>

                        <form className="form-box modal-form mt20">
                            <legend>급여 협의 폼</legend>
                            <div className="form-item">
                                <label className="input-tit">급여 협의</label>
                                <div className="radio-row">
                  <span className="text-radio">
                    <input type="radio" id="radio1" name="r1"
                           checked={payOption === 'keep'}
                           onChange={() => setPayOption('keep')} />
                    <label htmlFor="radio1">현 급여 유지</label>
                  </span>
                                    <span className="text-radio">
                    <input type="radio" id="radio2" name="r1"
                           checked={payOption === 'adjust'}
                           onChange={() => setPayOption('adjust')} />
                    <label htmlFor="radio2">급여 조정 요청</label>
                  </span>
                                </div>
                            </div>

                            {payOption === 'adjust' && (
                                <div className="form-item">
                                    <label className="input-tit">조정 방향</label>
                                    <div className="radio-row">
                    <span className="text-radio">
                      <input type="radio" id="radio3" name="r2"
                             checked={adjustDirection === 'deduct'}
                             onChange={() => setAdjustDirection('deduct')} />
                      <label htmlFor="radio3">차감 조정</label>
                    </span>
                                        <span className="text-radio">
                      <input type="radio" id="radio4" name="r2"
                             checked={adjustDirection === 'add'}
                             onChange={() => setAdjustDirection('add')} />
                      <label htmlFor="radio4">추가 조정</label>
                    </span>
                                    </div>
                                    <div className="line-input-box mt10">
                                        <input
                                            type="number"
                                            placeholder="금액을 입력하세요"
                                            value={adjustAmount}
                                            onChange={(e) => setAdjustAmount(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="info-row mt10 mb10">
                                <span className="label">최종 급여 금액</span>
                                <span className="cont">
                  <strong className="text-red">{finalPay().toLocaleString()}원</strong>
                </span>
                            </div>
                        </form>
                    </div>

                    <div className="modal-footer">
                        <div className="modal_btn">
                            <button type="button" className="btn cancel" onClick={onClose}>닫기</button>
                            <button
                                type="button"
                                className="btn confirm"
                                onClick={() => {
                                    if (payOption === 'adjust') {
                                        const amt = parseInt(adjustAmount) || 0;
                                        if (amt <= 0) {
                                            defaultAlert('조정 금액을 입력해주세요.');
                                            return;
                                        }
                                        if (adjustDirection === 'deduct' && amt > currentTotalPay) {
                                            defaultAlert('차감 금액은 현 급여 총액을 초과할 수 없습니다.');
                                            return;
                                        }
                                    }
                                    onConfirm(payOption, adjustDirection, parseInt(adjustAmount) || 0);
                                }}
                            >
                                신청
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        modalRoot
    );
};